export default "__VITE_ASSET__pOPp8sbJ__"